export default __webpack_public_path__ + "static/media/vantage90_splash.0e97b99f.svg";